export const QUALITY_LEVEL = 3;
export const FOV = 90;

export const YEAR_STEP = 2;
export const PLAY_DELAY = 110;

export const API_PATH = '/coastline-paradox/api';
export const GMAPS_CB_CLIENT = 'arts_and_culture.coastlines';

const isChromium = window.chrome;
const winNav = window.navigator;
const vendorName = winNav.vendor;
const isOpera = typeof window.opr !== 'undefined';
const isIEedge = winNav.userAgent.indexOf('Edge') > -1;
const isIOSChrome = winNav.userAgent.match('CriOS');

let isSlowDevice = false;

if (isIOSChrome) {
  // is Google Chrome on IOS
  isSlowDevice = true;
} else if (
  isChromium !== null
  && typeof isChromium !== 'undefined'
  && vendorName === 'Google Inc.'
  && isOpera === false
  && isIEedge === false
) {
  // is Google Chrome
  isSlowDevice = false;
} else {
  // not Google Chrome
  isSlowDevice = true;
}

export const IS_SLOW_DEVICE = isSlowDevice;

export const supportsMixBlendMode = (
  typeof window.getComputedStyle(document.body).mixBlendMode !== 'undefined'
);

export const isSafari = navigator.vendor
  && navigator.vendor.indexOf('Apple') > -1
  && navigator.userAgent
  && navigator.userAgent.indexOf('CriOS') === -1
  && navigator.userAgent.indexOf('FxiOS') === -1;

export default undefined;
